/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PmcMessageType } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

export interface PlayerControlInterface {
    /**
     * **Feature:** Sets flag to clear the player's browser cache on next launch.
     */
    clearBrowserCacheOnReboot(): Promise<void>;

    /**
     * **Feature:** Reboot the player's host system.
     *
     * @todo convert to asynchronous function
     */
    rebootSystem(): void | Promise<void>;
}

export function supportsPlayerControl(platform: unknown): platform is PlayerControlInterface {
    if (platform instanceof PlayerPmc) {
        return (
            platform.supportsMessage(PmcMessageType.ClearBrowserCacheOnReboot) &&
            platform.supportsMessage(PmcMessageType.RebootSystem)
        );
    }

    return (
        platform instanceof Object &&
        'clearBrowserCacheOnReboot' in platform &&
        'rebootSystem' in platform
    );
}
